import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /projects/ai-matching-results へのアクセスを
 * /projects/ai-matching-results/special-allocation-tax-survey にリダイレクトする。
 *
 * メニューの「AIマッチング結果」をクリックしたときのデフォルト遷移先（特別交付税）。
 */
export const Route = createFileRoute('/_protected/projects/ai-matching-results/')({
  beforeLoad: () => {
    throw redirect({ to: '/projects/ai-matching-results/special-allocation-tax-survey' });
  },
});
